// Application Constants
// Centralized configuration values to avoid magic numbers throughout the codebase

// ELO Rating System
export const ELO_CONSTANTS = {
  BASE_ELO: 1200,
  /** Starting rating for new players when a club has not set strength_rating */
  DEFAULT_STARTING_ELO: 1200,
  MIN_GAMES_FOR_PARTNERSHIP: 10,
  K_FACTOR_NEW_PLAYERS: 40,    // 0-5 games
  K_FACTOR_ESTABLISHED: 20,    // 5-15 games
  K_FACTOR_VETERAN: 10,        // 15+ games
};

// Session Management
export const SESSION_CONSTANTS = {
  CLEANUP_HOURS: 12,           // Clean up incomplete sessions older than 12 hours
  MAX_SESSIONS_DISPLAY: 10,    // Number of recent sessions to display
  MAX_PLAYERS_DISPLAY: 3,      // Number of top players to display
};

// UI Constants
export const UI_CONSTANTS = {
  MAX_NAME_LENGTH: 15,
  INITIALS_THRESHOLD: 25,
  ANIMATION_DURATION: 200,
};

/** Resolve starting ELO for new players: club default if set, otherwise 1200 */
export const getDefaultStartingElo = (clubStrengthRating) => {
  if (typeof clubStrengthRating === 'number' && clubStrengthRating > 0) {
    return clubStrengthRating;
  }
  return ELO_CONSTANTS.DEFAULT_STARTING_ELO;
};

// Database Defaults
export const DB_DEFAULTS = {
  CLUB_STRENGTH_RATING: 1200,
  PLAYER_GAMES_PLAYED: 0,
  PLAYER_WINS: 0,
  PLAYER_LOSSES: 0,
};

// Game Types
export const GAME_TYPES = {
  MIXED: 'mixed',
  LEVELS: 'levels',
};

// User Roles
export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  MEMBER: 'member',
};

// Club Roles
export const CLUB_ROLES = {
  ADMIN: 'admin',
  MEMBER: 'member',
};

// Session Status
export const SESSION_STATUS = {
  ACTIVE: 'active',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

// Season Status
export const SEASON_STATUS = {
  CURRENT: 'current',
  PAST: 'past',
  FUTURE: 'future',
};
